<template>
    <div>
        <!-- Blurry Background -->
        <transition
            enter-class="opacity-0"
            enter-active-class="ease-out"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-active-class="ease-out"
            leave-to-class="opacity-0"
        >
            <div
                v-show="isOpen"
                class="fixed inset-0 z-20 transition-opacity"
                @keydown.esc="closeRightSidebar"
            >
                <div
                    class="absolute inset-0 bg-black opacity-50"
                    tabindex="0"
                    @click="closeRightSidebar"
                />
            </div>
        </transition>

        <!-- Sidebar -->
        <aside
            class="fixed top-0 right-0 z-30 w-full h-full overflow-auto transition-all duration-300 ease-in-out transform bg-white sm:w-80 md:w-144"
            :class="isOpen ? 'translate-x-0' : 'translate-x-full'"
        >
            <div class="px-4 py-4">
                <slot name="heading" />
            </div>

            <div v-if="isOpen">
                <slot v-if="!componentName"> No data passed to render in RightSidebar. </slot>
                <component
                    :is="componentName"
                    v-else
                    :edit-data="editData"
                    @transactionComplete="closeRightSidebar"
                />
            </div>
        </aside>
    </div>
</template>

<script>
    import CreateBank from './BankForm.vue';
    import CreateProduct from './ProductForm.vue';
    import CreateCategory from './CategoryForm.vue';
    import CreateBrand from './BrandForm.vue';
    import PromocodeForm from './PromocodeForm.vue';
    import CreateConfig from './ConfigForm.vue';
    import CreateAdmin from './CreateAdmin.vue';
    import CreateSalesperson from './CreateSalesperson.vue';
    import CreateFeaturedImage from './CreateFeaturedImage.vue';
    import CreateProductFeaturedImage from './CreateProductFeaturedImage.vue';

    export default {
        name: 'RightSidebar',

        components: {
            CreateProduct,
            CreateCategory,
            PromocodeForm,
            CreateBrand,
            CreateBank,
            CreateConfig,
            CreateFeaturedImage,
            CreateProductFeaturedImage,
            CreateAdmin,
            CreateSalesperson,
        },

        props: {
            isOpen: {
                type: Boolean,
                default: false,
            },

            componentName: {
                type: String,
                default: null,
            },

            editData: {
                type: Object,
                default: null,
            },
        },

        methods: {
            closeRightSidebar() {
                this.$emit('closeRightSidebar');
            },
        },
    };
</script>
